module.exports = __webpack_public_path__ + "static/media/pet-race-cat.5e05a806.svg";